import '../../styles/grid.scss';

import { HTMLAttributes, ReactNode } from 'react';

export interface GridRowProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

const GridRow = function ({ children, ...props }: GridRowProps) {
  return (
    <div className="govuk-grid-row" {...props}>
      {children}
    </div>
  );
};

export interface GridColumnProps extends HTMLAttributes<HTMLDivElement> {
  alignSelf?: 'auto' | 'end' | 'start';
  width?: 'full' | 'one-half' | 'one-third' | 'two-thirds' | 'one-quarter' | 'three-quarters';
  desktopWidth?: 'full' | 'one-half' | 'one-third' | 'two-thirds' | 'one-quarter' | 'three-quarters';
  children?: ReactNode;
}

const GridColumn = function ({ width, desktopWidth, children, ...props }: GridColumnProps) {
  let className = width ? `govuk-grid-column-${width}` : '';
  className += desktopWidth ? ` govuk-grid-column-${desktopWidth}-from-desktop` : '';
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
};

export { GridColumn, GridRow };
